import React, { useEffect, useMemo } from "react";
import { useFormikContext } from "formik";
import FormikInput from "../../Formik/FormikInput";
import FormikSelect from "../../Formik/FormikSelect";
import styled from "styled-components";
import { useLanguage } from "../../LangTranslation/LanguageContext";

const ExtraInformationContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
`;

const ExtraInformation = ({
  availableCountries,
  stateList,
  activeCustomersList,
  handleChangeCountry,
  handleCustomSearch,
  availablePartnerTitle,
  availableCompaign,
  languageList,
  disabled,
}) => {
  const { setFieldValue, values } = useFormikContext();
  const { language, translations } = useLanguage();
  const t = translations[language];

  return (
    <div>
      <ExtraInformationContainer className="row g-3 px-2">
        <div className="row p-0 justify-content-between align-items-center">
          <div className="col">
            <h5
              className="me-2 mb-2 "
              style={{
                fontFamily: "Inter",
                color: "#4E5D78",
                fontWeight: 600,
              }}
            >
              {t["Contacts Information"]}
            </h5>
          </div>
        </div>

        <div className="col-md-4 ">
          <FormikInput
            name="partner_name"
            label={t["Company Name"]}
            disabled={disabled}
          />
        </div>
        <div className="col-md-4">
          <FormikInput
            type="text"
            name="street"
            label={t["Address"]}
            disabled={disabled}
            options={activeCustomersList}
          />
        </div>
        <div className="col-md-4">
          <FormikInput
            type="text"
            name="street2"
            label={t["Address"]}
            disabled={disabled}
          />
        </div>
        <div className="col-md-3">
          <FormikInput
            type="text"
            name="city"
            label={t["City"]}
            disabled={disabled}
          />
        </div>

        <div className="col-md-3">
          <FormikSelect
            name="state_id"
            options={stateList}
            disabled={disabled}
            label={t["State"]}
            //automatically state will define in options if selected country have state
            handleSearch={({ ...args }) =>
              handleCustomSearch({
                ...args,
                model: "res.country.state", //state modal
                args: values.country_id
                  ? [["country_id", "=?", values.country_id]]
                  : [],
              })
            }
          />
        </div>
        <div className="col-md-3">
          <FormikInput
            type="number"
            name="zip"
            label={t["Zip"]}
            disabled={disabled}
          />
        </div>
        <div className="col-md-3">
          <FormikSelect
            name="country_id"
            options={availableCountries}
            disabled={disabled}
            label={t["Country"]}
            handleSearch={({ ...args }) =>
              handleCustomSearch({
                ...args,
                model: "res.country",
              })
            }
            onChange={(option, event) => {
              handleChangeCountry(option, event, values, setFieldValue);
            }}
          />
        </div>
        <div className="col-md-3 ">
          <FormikInput
            name="contact_name"
            label={t["Contact Name"]}
            disabled={disabled}
          />
        </div>
        <div className="col-md-3">
          <FormikSelect
            name="title"
            label={t["Title"]}
            options={availablePartnerTitle}
            handleSearch={({ ...args }) => {
              handleCustomSearch({ ...args, model: "res.partner.title" });
            }}
            disabled={disabled}
          />
        </div>
        <div className="col-md-3 ">
          <FormikInput
            name="function"
            disabled={disabled}
            label={t["Job Position"]}
          />
        </div>
        <div className="col-md-3 ">
          <FormikInput name="mobile" disabled={disabled} label={t["Mobile"]} />
        </div>
        <div className="col-md-6 ">
          <FormikInput
            name="website"
            disabled={disabled}
            label={t["Website"]}
          />
        </div>
        <div className="col-md-6 ">
          <FormikSelect
            name="lang_id"
            options={languageList}
            label={t["Language"]}
            handleSearch={({ ...args }) => {
              handleCustomSearch({ ...args, model: "res.lang" });
            }}
            disabled={disabled}
          />
        </div>
        {/* <h5
          className="me-2 mb-2 "
          style={{
            fontFamily: "Inter",
            color: "#4E5D78",
            fontWeight: 600,
          }}
        >
          {t["Marketing"]}
        </h5>

        <div className="col-md-4 ">
         
          <FormikSelect
            name="compaign_id"
            disabled={disabled}
            options={availableCompaign}
            label={t["Compaign"]}
          />
        </div>
        <div className="col-md-4 ">
          <FormikSelect
            name="medium_id"
            label={t["Medium"]}
            options={activeCustomersList}
            disabled={disabled}
          />
        </div>
        <div className="col-md-4">
          <FormikSelect
            name="source_id"
            label={t["Source"]}
            disabled={disabled}
            value={values.source_id}
            onChange={(option) => setFieldValue("source_id", option.value)}
          />
        </div>
        <h5
          className="me-2 mb-2 "
          style={{
            fontFamily: "Inter",
            color: "#4E5D78",
            fontWeight: 600,
          }}
        >
          {t["Misc"]}
        </h5>

        <div className="col-md-4">
          <FormikSelect
            name="referred"
            label= {t["Referred by"]}
          />
        </div> */}
      </ExtraInformationContainer>
    </div>
  );
};
export default ExtraInformation;
